export type FeedbackSeverity = "success" | "info" | "warning" | "error";
export interface FeedbackEntry {
  id: number;
  message: string;
  severity: FeedbackSeverity;
  count: number;
  revision: number;
  coalescible?: boolean;
}

/** Only identical plain messages coalesce. Rich/actionable messages keep their own actions. */
export function enqueueFeedback<T extends FeedbackEntry>(
  queue: T[],
  next: T,
  coalesce = true,
): T[] {
  const index = coalesce
    ? queue.findIndex(
        (item) =>
          item.coalescible !== false &&
          item.message === next.message &&
          item.severity === next.severity,
      )
    : -1;
  if (index < 0) return [...queue, next];
  return queue.map((item, i) =>
    i === index
      ? {
          ...next,
          id: item.id,
          count: item.count + 1,
          revision: item.revision + 1,
        }
      : item,
  );
}

export function feedbackDuration(
  severity: FeedbackSeverity,
  duration?: number | null,
) {
  if (duration !== undefined) return duration;
  return severity === "error" || severity === "warning" ? null : 4500;
}
